import {ProductInCatalog} from '@treez/commons/sharedTypings/product';

export enum HighLightProductAction {
    CLEAR_HIGHLIGHTED_PRODUCTS = 'clear',
    HIGHLIGHT_MULTIPLE_PRODUCTS = 'highlightMultipleProducts',
    HIGHLIGHT_PRODUCT = 'highlightProduct',
}

const {CLEAR_HIGHLIGHTED_PRODUCTS, HIGHLIGHT_MULTIPLE_PRODUCTS, HIGHLIGHT_PRODUCT} =
    HighLightProductAction;

export const highlightMultipleProducts = (value: ProductInCatalog[]) => ({
    type: HIGHLIGHT_MULTIPLE_PRODUCTS,
    value,
});

export const highlightProduct = (value: ProductInCatalog) => ({
    type: HIGHLIGHT_PRODUCT,
    value,
});

export const clearHighlightedProducts = () => ({
    type: CLEAR_HIGHLIGHTED_PRODUCTS,
});
